// 引入需要暴露的类
import install from './install'
import BuryPoint from './bury-point'
import BuryTool from './bury-tool'

// types
export {
  BuryToolOptions,
  PositionConfig,
  PositionConfigItem,
  TransferDataBFS,
  BuryParams,
} from './types/bury-tool'

// types
export {
  BuryPointOptions,
  BuryPointModules,
} from './types/bury-point'


export {
  BuryPoint,
  BuryTool,
  install,
}
// default
export default {
  BuryPoint,
  BuryTool,
  install,
}
